// extracted by mini-css-extract-plugin
export default {"title":"styles_title__BRTCA","formContainer":"styles_formContainer__nfeiW","btnWrapper":"styles_btnWrapper__ul-sB","btn":"styles_btn__gNWHW"};